import JumboTextField from "@jumbo/components/JumboFormik/JumboTextField";
import Div from "@jumbo/shared/Div";
import { FormControl, Grid, MenuItem } from "@mui/material";
import { Label } from "app/pages/presentation/module/form/types";

const DsokPrinter = ({ device, setFieldValue, values, t }) => {
  return (
    <>
      <Grid item xs={12} md={4} lg={4}>
        <Div sx={{ mt: 1, mb: 1 }}>
          <JumboTextField
            fullWidth
            name={`customer.devices.${device}.ekasa.localPort`}
            label={t("pages.dsokDetails.localPort")}
          />
        </Div>
      </Grid>
      <Grid item xs={12} md={4} lg={4}>
        <Div sx={{ mt: 1, mb: 1 }}>
          <JumboTextField
            fullWidth
            InputProps={{
              readOnly: true,
            }}
            name={`customer.devices.${device}.ekasa.serverPort`}
            label={t("pages.dsokDetails.serverPort")}
          />
        </Div>
      </Grid>
      <Grid item xs={12} md={2} lg={2}>
        <FormControl sx={{ mt: 1, mb: 1 }} fullWidth>
          <JumboTextField
            select
            InputLabelProps={{ required: false }}
            name={`customer.devices.${device}.ekasa.encoding`}
            value={values.customer.devices[device].ekasa?.encoding}
            onChange={(e) =>
              setFieldValue(
                `customer.devices.${device}.ekasa.encoding`,
                e.target.value
              )
            }
            label={
              <Label
                text={t(
                  "pages.dsokDetails.appSettings.tabs.printer.printerEncoding"
                )}
                helpText={t(
                  "pages.dsokDetails.appSettings.tabs.printer.printerEncodingHelp"
                )}
                required={false}
              />
            }
          >
            <MenuItem value="cp852">cp852</MenuItem>
            <MenuItem value="CP1250">CP1250</MenuItem>
          </JumboTextField>
        </FormControl>
      </Grid>
    </>
  );
};

export default DsokPrinter;
